import { Space, Typography } from "antd";

export type ExpiringLeasesCollapseLabelProps = {
  title: string;
  count: number;
  recordsLabel: string;
};

export const ExpiringLeasesCollapseLabel = ({
  title,
  count,
  recordsLabel,
}: ExpiringLeasesCollapseLabelProps) => (
  <div className="custom-table-header">
    <Space size="small" className="custom-table-header-title">
      <Typography.Text strong>{title}</Typography.Text>
      <Typography.Text italic>
        {count} {recordsLabel}
      </Typography.Text>
    </Space>
  </div>
);
